import { ACTIONS } from '../Constants';

const initialState = {
    byId: {},
    explorePageDimensions: [],
};

const dimensions = (state = initialState, action) => {
    let newById;
    let reduced;
    let dimension;

    switch (action.type) {
        case ACTIONS.GET_MANY_DIMENSIONS: {
            const { dimensions = [] } = action.payload;

            reduced = dimensions.reduce((prev, dimension) => {
                prev[dimension._id] = dimension;
                return prev;
            }, {});
            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById
            };
        }

        case ACTIONS.GET_EXPLORE_PAGE_DIMENSIONS: {
            const { body } = action.payload;

            return {
                ...state,
                explorePageDimensions: body.dimensions ? body.dimensions: []
            };
        }

        case ACTIONS.GET_DIMENSION:
        case ACTIONS.PUT_DIMENSION_SUCCESS:
        case ACTIONS.POST_DIMENSION_SUCCESS: {
            ({ dimension } = action.payload);
            newById = {
                ...state.byId,
                [dimension._id]: dimension
            };
            return {
                ...state,
                byId: newById
            };
        }

        default:
            return state;
    }
};

export default dimensions;
